import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;

//诉求列表
export const demandList = (params) => {
  return axios.get(`${base}/api/Demand/Get`, { params: params });
};
//新增诉求
export const addDemand = (data) => {
  return axios.post(`${base}/api/Demand/Post`, data);
};
//删除诉求
export const deleteDemand = (params) => {
  return axios.delete(`${base}/api/Demand/Delete`, { params});
};

//编辑诉求
export const editDemand = (data) => {
  return axios.put(`${base}/api/Demand/Put`, data);
};
//获取诉求详情
export const getDemandDetail = (params) => {
  return axios.get(`${base}/api/Demand/Get/${params.id}`, { params: {} });
};